import React, {useState} from 'react';
import { useAuth } from '../../context/AuthContext';

const AI = () => {
  const [prompt, setPrompt] = useState('');
  const [responseGemini, setResponseGemini] = useState('');

  const { user } = useAuth();
  const user_id = user.id;

  const viewFile = async () => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/view/${user_id}`;
    window.open(url, '_blank');
  };

  const seeGeminiResponse = async () => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/extract_text_and_gemini_response`, {
      method: 'POST',
      headers: {'Content-Type' : 'application/json'},
      body: JSON.stringify({'prompt': prompt, 'user_id': user_id})
    });
    const result = await response.json();
    await setResponseGemini(result.response);
  }
  
  return (
    <div>
      <h1>AI Assistance</h1>

      <section>
        <h3>View Tenancy</h3>
        <p>To view the tenancy please click the below button.</p>
        <button onClick={viewFile}>View File</button>
      </section>

      <section>
        <h3>AI Assistance</h3>
        <p>For queries of your tenancy please input them below:</p>
        
        <textarea
          rows="4"
          cols="50"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="E.g., What is my deposit amount?"
          style={{ width: '98%', padding: '10px', fontSize: '16px' }}
        />

        <button onClick={seeGeminiResponse} style={{ marginTop: '10px' }}>See Response</button>
      </section>

      {responseGemini && (
        <section style={{ marginTop: '30px' }}>
          <h3>Response</h3>
          <div
            style={{
              whiteSpace: 'pre-line',
              backgroundColor: '#f9f9f9',
              border: '1px solid #ddd',
              padding: '15px',
              borderRadius: '4px',
              fontFamily: 'monospace',
            }}
          >
            {responseGemini}
          </div>
        </section>
      )}

    </div>
  );
}

export default AI;
